export default "__VITE_ASSET__cbb36f57__"